import styled from 'foundations-theming/utils';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import { createContext, createRef, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HEADER_HEIGHT = 50;
const FOOTER_HEIGHT = 50;
const StyledRightUIBox = styled(UIBox).withConfig({
  displayName: "ActionConfigScrollColumns__StyledRightUIBox",
  componentId: "sc-1nubm63-0"
})(["border-left:1px solid ", ";height:100%;"], ({
  theme
}) => theme.color['do-not-use-battleship']);
const StyledLeftColumn = styled.div.withConfig({
  displayName: "ActionConfigScrollColumns__StyledLeftColumn",
  componentId: "sc-1nubm63-1"
})(["flex-basis:", "px;flex-grow:1;flex-shrink:0;height:100%;"], SIDE_PANEL_WIDTH);
const StyledLeftColumnScroll = styled.div.withConfig({
  displayName: "ActionConfigScrollColumns__StyledLeftColumnScroll",
  componentId: "sc-1nubm63-2"
})(["max-height:calc( 100% - ", "px );flex:1;overflow-x:hidden;overflow-y:auto;", ""], ({
  hasTestFooter
}) => hasTestFooter ? HEADER_HEIGHT + FOOTER_HEIGHT : HEADER_HEIGHT, ({
  isFullScreen
}) => !isFullScreen && `width: ${SIDE_PANEL_WIDTH}px;`);
const StyledLeftColumnContentHeader = styled.div.withConfig({
  displayName: "ActionConfigScrollColumns__StyledLeftColumnContentHeader",
  componentId: "sc-1nubm63-3"
})(["", ""], ({
  isFullScreen
}) => !isFullScreen && `width: ${SIDE_PANEL_WIDTH}px;`);
/**
 *
 * DEV NOTE: This component is built explicitly setup scrolling in a two column layout.
 * Any changes here or upline to the height of the components can have adverse affects
 * on action configs ability to scroll or fill the vertical space of the panel.
 *
 */

const ActionConfigScrollContext = /*#__PURE__*/createContext(undefined);
const ActionConfigScrollColumns = ({
  isFullScreen,
  leftColumnContent,
  leftColumnContentHeader,
  rightColumnContent,
  testFooterContent
}) => {
  const scrollRef = /*#__PURE__*/createRef();
  return /*#__PURE__*/_jsxs(UIFlex, {
    style: {
      height: '100%',
      alignItems: 'stretch'
    },
    children: [/*#__PURE__*/_jsxs(StyledLeftColumn, {
      children: [leftColumnContentHeader && /*#__PURE__*/_jsx(StyledLeftColumnContentHeader, {
        isFullScreen: isFullScreen,
        children: leftColumnContentHeader
      }), /*#__PURE__*/_jsx(ActionConfigScrollContext.Provider, {
        value: scrollRef,
        children: /*#__PURE__*/_jsx(StyledLeftColumnScroll, {
          ref: scrollRef,
          isFullScreen: isFullScreen,
          hasTestFooter: !!testFooterContent,
          children: leftColumnContent && leftColumnContent
        })
      }), testFooterContent]
    }), rightColumnContent && /*#__PURE__*/_jsx(StyledRightUIBox, {
      children: rightColumnContent
    })]
  });
};
export function useActionConfigScrollContext() {
  const context = useContext(ActionConfigScrollContext);
  return context;
}
export default ActionConfigScrollColumns;